<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop no-close-on-esc hide-header-close :id="theme" header-class="my-class" size="lg" title="患者登録">
      <b-tabs>
        <b-tab title="QRで登録する" @click="setSelectedTab('tab2')">
          <div v-if="qrBase64" class="col-12 text-center p-3" style="height: 65vh;">
            <img ref="qrImage" :src="'data:image/svg+xml;base64, ' + qrBase64" class="custom-qr" />
          </div>
        </b-tab>
        <b-tab title="携帯番号で登録する"  @click="setSelectedTab('tab1')">
          <div class="row" style=" height: 65vh;">
            <div class="col-12" style="margin-top: 100px;">
              <b-form-group class="mb-3">
                <label class="text-label">携帯番号
                  <span class="text-label-required bg-required-label badge badge-soft-danger font-size-11 me-2">必須</span>
                </label>
                <b-form-input type="text" @blur="showUserInfo" @keyup.enter="showUserInfo" maxlength="11" @keydown="restrictNonNumeric"></b-form-input>
                <div class="text-danger" v-if="errorMessage.length">{{ errorMessage }}</div>
              </b-form-group>
            </div>
            <div class="col-12" style="margin-top: -100px;">
              <div class="row gap-info">
                <div class="col-12">
                  <div class="mt-3">
                    <label class="text-labelInfo"> 名前 </label>
                    <h6 class="text-table">
                      <b>{{ selectedUser.information?.fullname || '-' }}</b>
                    </h6>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mt-3">
                    <label class="text-labelInfo"> 性別 </label>
                    <h6 class="text-table">
                      <b>{{ genderName(selectedUser.information?.sex) || '-' }}</b>
                    </h6>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mt-3">
                    <label class="text-labelInfo"> 生年月日 </label>
                    <h6 class="text-table">
                      <b>{{ selectedUser.information?.birthday || '-' }}</b>
                    </h6>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mt-3">
                    <label class="text-labelInfo"> 都道府県 </label>
                    <h6 class="text-table">
                      <b>{{ selectedUser.information?.city || '-' }}</b>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>


      <template #modal-footer >
        <div v-if="selectedTab === 'tab1'" class="w-100 row p-0" style="margin-top: 20px; margin-bottom: 20px;">
          <div class="col p-0" style="padding-right: 2px !important">
            <b-button class="w-100" type="button" @click="closeModal()" variant="outline-danger">キャンセル</b-button>
          </div>
          <div class="col p-0 ps-3">
            <b-button type="button" :disabled="disabled()" @click="submit" class="w-100 btn-lyg" style="padding-left: 2px !important" variant="primary">登録</b-button>
          </div>
        </div>
        <div v-else class="w-100 row p-0" style="margin-top: 20px; margin-bottom: 20px;">
          <div class="col p-0 " style="padding-right: 2px !important">
            <b-button class="w-100" type="button" @click="closeModal()" variant="outline-danger">閉じる</b-button>
          </div>
          <div class="col p-0 ps-3">
            <b-button class="w-100 btn-lyg" type="button" @click="printImage" >印刷する</b-button>
          </div>
        </div>

      </template>

    </b-modal>
  </div>
</template>

<script>
import api from "@/api";
import {mixin} from "@/helpers/Vue-Mixin";
import {getProfile} from "../../helpers/Auth";

const currentUser = getProfile();

export default {
  mixins: [mixin],

  components: {
    VueHtml2pdf: () => import(/* webpackPrefetch: true */ "vue-html2pdf"),
  },

  props: ["isShow"],
  data() {
    return {
      show: false,
      selectedPatientId: '',
      selectedUser: {},
      errorMessage: '',
      qrBase64: null,
      selectedTab: "tab2",
    };
  },

  watch: {
    isShow: {
      handler(value) {
        this.show = value;
      },
    },
  },
  created() {
    this.getQr();
  },

  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },

  methods: {

    restrictNonNumeric(event) {
      const key = event.key;
      if (!/[\d]/.test(key) && key !== 'Backspace' && key !== 'Tab' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
        event.preventDefault();
      }
    },

    setSelectedTab(tabName) {
      this.selectedTab = tabName;
    },

    printImage() {
      const qrImage = this.$refs.qrImage; // Lấy thẻ img bằng $refs
      const printWindow = window.open('', '', 'width=1000,height=600');
      const title = currentUser.facility?.name || '';
      printWindow.document.write(`<div style="text-align: center;margin-top: 50px">施設管理者: ${title} </div>`);
      printWindow.document.write('<div style="text-align: center;margin-top: 100px">');
      printWindow.document.write('<img src="' + qrImage.src + '" style="width:400px;height: auto;"/>');
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
      printWindow.close();
    },

    async showUserInfo(event) {
      if (this.selectedPatientId !== event.currentTarget.value) {
        this.errorMessage = '';
        this.selectedPatientId = event.currentTarget.value;
        try {
          const result = await api.getUserByPatientId(event.currentTarget.value);

          this.selectedUser = result.data;
        } catch (error) {
          if (error.status === 404) {
            this.errorMessage = '患者が見つかりません。';
          }

          this.selectedUser = {};
        }
      }
    },
    async getQr() {
      const res = await api.getQr();
      this.qrBase64 = res.data.qr;
    },
    closeModal() {
      this.$emit("close");
      this.show = false;
      this.selectedUser = {};
      this.selectedPatientId = '';
    },
    disabled() {
      return !window.Boolean(this.selectedUser.id);
    },
    async submit() {
      this.show = false;
      this.$emit("close");

      try {
        await api.joinUserToFacility(this.selectedUser.id, currentUser.facility.id);

        this.$emit("added");
      } catch (error) {
        window.toastr.error("ユーザー登録に失敗しました。");
      }

      this.selectedUser = {};
      this.selectedPatientId = '';
    },
  }
};
</script>

<style scoped>
/* ::v-deep .modal-header {
  background: #007e41;
  height: 70px;
} */

::v-deep .modal-title {
  display: block;
  width: 100%;
  text-align: center;
  padding: 1rem;
  font-weight: 700;
  color: #fff !important;
  font-size: 20px;
}

.custom-qr {
  width: 100%;
  height: 100%;
  max-width: 360px;
}

</style>
